import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface codeSliceType {
  code: string;
  getCode: boolean;
  codeStreaming: boolean;
  codeError: boolean;
  codeStreamingCompleted: boolean;
  errorLog: any[];
}

interface ErrorLogEntry {
  error: any;
  errorInfo: any;
} 

const initialCodeSliceObject: codeSliceType = {
  code: "",
  getCode: false,
  codeStreaming: false,
  codeError: false,
  codeStreamingCompleted: false,
  errorLog: []
};

const codeSlice = createSlice({
  name: "codeObject",
  initialState: initialCodeSliceObject,
  reducers: {
    updateCode: (state, action: PayloadAction<string>) => {
      state.code = action.payload;
    },

    updateGetCode: (state, action: PayloadAction<boolean>) => {
      state.getCode = action.payload;
    },

    updateCodeStreaming: (state, action: PayloadAction<boolean>) => {
      state.codeStreaming = action.payload;
    },

    updateCodeError: (state, action: PayloadAction<boolean>) => {
      state.codeError = action.payload;
    },

    updateCodeStreamingCompleted: (state, action: PayloadAction<boolean>) => {
      state.codeStreamingCompleted = action.payload;
    },

    addErrorLog: (state, action: PayloadAction<any>) => {
      console.log(action.payload?.toString())
      state.errorLog.push(action.payload?.toString());
    },

    clearErrorLog: (state) => {
      state.errorLog = [];
    },
  },
});

export default codeSlice.reducer;
export const {
  updateCode,
  updateGetCode,
  updateCodeStreaming,
  updateCodeError,
  updateCodeStreamingCompleted,
  addErrorLog,
  clearErrorLog
} = codeSlice.actions;
